import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { DocumentParams, DocumentResponse } from '../../models/DocumentLibrary';

const USER_URL = '/api/v1/document/list';

const useDocumentLibrarySWR = (params: DocumentParams) => {
    const fetchUser = (query, params): Promise<DocumentResponse> => {
        return httpApi
            .get<DocumentResponse>(query, params)
            .then((res) => {
                return res.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        [USER_URL, params],
        ([url, params]) => fetchUser(url, params),
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    return {
        documents: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useDocumentLibrarySWR;
